import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import dataSecurityImage from "../../../assets/smartbuilding/dataSecurity.jpg";

export default function DataSecurity(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container">
      <div className="container-small">
        <h1 className="title-gradient">{textContent.data.title[language]}</h1>
      </div>
      {!isMobile ? <div className="container-empty-small"></div> : null}
      {!isMobile ? (
        <div className="data-security">
          <div className="data-security-text">
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html: textContent.data.description.description1[language],
              }}
            />
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html: textContent.data.description.description3[language],
              }}
            />
          </div>
          <div className="data-security-image">
            <img src={dataSecurityImage} alt="" />
          </div>
        </div>
      ) : (
        <div className="data-security-mobile">
          <img src={dataSecurityImage} alt="" />
          {/* <div className="container-empty-extra-small" /> */}
          <div className="data-security-text">
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html: textContent.data.description.description1[language],
              }}
            />

            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html: textContent.data.description.description3[language],
              }}
            />
          </div>
        </div>
      )}
    </section>
  );
}
